import {ServiceRequest} from "../utils/service-request"
import {
    CADASTRO_DOCUMENTS_PATH,
    CADASTRO_DOCUMENTS_DOWNLOAD_PATH
} from "../utils/api-routes"

class RegisterDocumentService {
    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    getFilesFromDirectoryFolder = (directory, origin) => {
        const query = `diretorio=${directory}&origem=${origin}`
        return this.serviceRequest.get(`${CADASTRO_DOCUMENTS_PATH}?${query}`)
    }

    openFileFromDirectory = (id,directory, origin, arquivo) => {
        const query = `diretorio=${directory}&origem=${origin}&arquivo=${arquivo}`
        return this.serviceRequest.getBlob(`${CADASTRO_DOCUMENTS_PATH}/${id}?${query}`)
    }

    deleteFile = (directory, origin, file) => {
        const query = `diretorio=${directory}&origem=${origin}&arquivo=${file}`
        return this.serviceRequest.delete(`${CADASTRO_DOCUMENTS_PATH}?${query}`)
    }

    registerDocument = (directory, origin, accessType, filename, file) => {
        const formData = new FormData()

        formData.append('diretorio', directory)
        formData.append('origem', origin)
        formData.append('tipo_acesso', accessType)
        formData.append('nome_arquivo', filename)
        formData.append('arquivo', file)

        return this.serviceRequest.postFormData(CADASTRO_DOCUMENTS_PATH, formData)
    }

    updateDocumentTypeAccess = (id, type) => {
        const body = {
            tipo_acesso: type
        }
        return this.serviceRequest.patch(`${CADASTRO_DOCUMENTS_PATH}/${id}/acesso`, body)
    }

    downloadFileFromDirectory = (directory, file) => {
        const query = new URLSearchParams({
            diretorio: directory,
            arquivo: file,
        }).toString()

        return this.serviceRequest.get(`${CADASTRO_DOCUMENTS_DOWNLOAD_PATH}?${query}`)
    }
}

export default RegisterDocumentService